import { defineStore } from 'pinia'
export default defineStore({
  id: 'tripDataTable',
  persist: true,
  state: () => {
    return {
      isTripArchive: false,
      isDebitArchive: false,
      isInvoiceArchive: false
    }
  },
  actions: {
    setIsTripArchive: function (payload: any) {
      this.isTripArchive = payload
    },
    setIsDebitArchive: function (payload: any) {
      this.isDebitArchive = payload
    },
    setIsInvoiceArchive: function (payload: any) {
      this.isInvoiceArchive = payload
    }
  },
  getters: {
    getIsTripArchive: (state: any) => state.isTripArchive,
    getIsDebitArchive: (state: any) => state.isDebitArchive,
    getIsInvoiceArchive: (state: any) => state.isInvoiceArchive
  }
})
